export default "/images/more-horizontal.svg?43ecf751e62ad2cc0518828d94a22f0d";